module.exports = __webpack_public_path__ + "static/media/8.537d9baf.jpg";